import React, { Component } from 'react';

import Add from './add';
import Edit from './edit';

import Loading from '../../loading';
import Server from '../../../functions/server'
import $ from "jquery";


class Characteristics extends Component {

  state = {
    data: null,
    load: false,
    message: '',
  }

  componentDidMount() {
    this.getChar();
  }

  componentDidUpdate(props) {
    if (props.partno != this.props.partno) {
      this.getChar();
    }
  }

  getChar() {
    let context = this;
    context.setState({
      load: true,
      message: 'Getting Spares Characteristics!!!'
    });
    let data1 = {'partno': this.props.partno};
    $.ajax({
      type: 'POST',
      data: data1,
      url: Server() + 'spares/getcharacteristics.php',
      success: function(data)
      {
        data = JSON.parse(data);
        if (data.length >= 1) {
          context.setState({
            load: false,
            data: data,
          });
        }
        else {
          context.setState({
            load: false,
            data: null,
          });
        }
      },
      error: function(err)
      {
        context.setState({
          load: false,
        });
        alert('Try again!!!!')
      }
    });
  }


  render() {
    let { load, message } = this.state;
    let loading, edit;
    if (load) {
      loading = (<Loading load={load} message={message} />)
    }
    if (this.state.data) {
      edit = this.state.data.map((z) => {
        return (
          <Edit partno={this.props.partno} data={z}/>
        )
      })
    }
    return (
      <div>
        { this.state.data ?
          (<div>{edit}</div>) :
          (<div><Add partno={this.props.partno} /></div>) }
        {loading}
      </div>
    );
  }
}

export default Characteristics;
